export const dictionary = {
  days: ['сут', 'дня', 'дней', 'мес'],
  services: ['услуга', 'услуги', 'услуг'],
  connected: ['Подключена', 'Подключены', 'Подключено'],
  monthRULocale: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ],
};
